export default "<i *ngIf=\"loading\" class=\"ds-button__spinner fa fa-spinner fa-spin\" aria-hidden=\"true\"></i>\r\n<ng-content></ng-content>\r\n";